<template>
  <div>
    <h2 class="font-bold text-gray-700">Kardex consulta el movimiento de tus productos por periodo</h2>
    <MainKardex />
  </div>
</template>

<script>
import MainKardex from "@/components/Kardex/MainKardex.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "KardexData",
  components: {
    MainKardex,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
